import { EnumPreventivoDTOStato } from '@framework/api-client';
import { ISubmissionQuote } from './ISubmissionQuote';

export class SubmissionQuoteLogic {
  static requiresAcceptance(quote: ISubmissionQuote) {
    return quote.stato === EnumPreventivoDTOStato.ATTESA_APPROVAZIONE;
  }
}
